import axios from 'axios'
import router from '../router'
/* 登录 Start*/
const authLogin = (params) => {

//   let res =this.$http.get("http://180.101.236.110:8081/inserts/logonNj", params);
// alert(JSON.stringify(res))
//   if(res.data.status===200){
//     sessionStorage.setItem("userId", res.message);
//     window.location.href="http://180.101.236.110:8081/inserts/userLoginWx?openid="+response.message;
//   }

  return axios({
    // url: 'http://180.101.236.110:8081/inserts/logonNjWX',
    url: 'http://weixin.njrsrc.cn/inserts/logonNjWX',
    method: 'get',
    params
  }).then((response) => {
    if(response.status==200){
      sessionStorage.setItem("logonNjWX", response.data.message);
      router.push(
        {
          name: 'questionnaireWXApp',
        }
      );
    }else{
      alert('授权失败');
    }

  });

}
export default {
  authLogin,
}





// WEBPACK FOOTER //
// ./src/utils/logonWX.js